<template>
  <div class="relative"
       v-on-click-away="hidePopup"
       v-show="!user_info.dirty"
       @click="showPopup = !showPopup">
    <div class="user-block group">
      <div class="letter">{{ !!displayedName && displayedName[0].toUpperCase() }}</div>
      <div class="mr-6">
        <div class="text-md font-medium leading-6 truncate" style="max-width: 118px;">{{ displayedName }}</div>
        <div class="space-name"
             v-show="spacesList.length > 1">{{ current_space.data.title }}
        </div>
      </div>
      <IconBars class="text-red-light group-hover:text-white ml-auto -mt-0-5 transition duration-200"/>
    </div>
    <HeaderUserBlockPopup v-show="showPopup"/>
  </div>
</template>
<script>
import HeaderUserBlockPopup from '@/components/common/Header/HeaderUserBlock/HeaderUserBlockPopup.vue';
import {mapGetters, mapState} from "vuex";
import IconBars from "@/components/icons/IconBars";
import {directive as onClickAway} from 'vue-clickaway';

export default {
  name: "UserBlock",
  components: {IconBars, HeaderUserBlockPopup},
  directives: {
    onClickAway: onClickAway
  },
  data() {
    return {
      showPopup: false,
    }
  },
  computed: {
    ...mapState('cabinet/user', ['user_info']),
    ...mapGetters('cabinet/user', ['displayedName']),
    ...mapState('space', ['current_space']),
    ...mapGetters('space', ['spacesList']),
  },
  methods: {
    hidePopup() {
      setTimeout(() => {
        this.showPopup = false;
      })
    }
  }
}
</script>
<style scoped lang="scss">
.user-block {
  @apply flex items-center min-w-188px pr-6 rounded relative
  text-white cursor-pointer text-lg
  transition duration-200
  bg-red shadow-red;
  height: 36px;
  border-radius: 4px;

  .letter {
    @apply flex items-center justify-center m-2 rounded;
    height: 28px;
    width: 28px;
    margin-right: 14px;
    background: #C53759;
  }

  .space-name {
    @apply text-xs;
    color: #FFBCCC;
  }

  &:hover {
    @apply bg-red-hover shadow-redHover;
  }
}
</style>